/**
 * THANH CHON TRANG - phan con lai trong thanh ben.
 *
 * Cac NUT THAO TAC (xoay, xoa, chen trang trang, tach, ghep, trich xuat) da len
 * thanh cong cu tren theo yeu cau cua nguoi dung. O day chi con nhung dieu khien
 * ma anh thu nho ngay ben duoi la ngu canh cua chung:
 *
 *  1. CHON TRANG = BAM ANH THU NHO. Nguoi dung noi o nhap khoang ("1-3, 7, 9-"),
 *     nut "Chọn tất cả" va "Bỏ chọn" la KHONG CAN THIET - da bo. Chon bang cach
 *     bam thang vao anh thu nho (giu Ctrl chon them, Shift chon ca dai). Dong
 *     trang thai ben duoi cho biet dang chon nhung trang nao.
 *
 *  2. CANH BAO MOT LAN, KHONG PHAI MOI LAN BAM. Thao tac trang lam mat bookmark
 *     va lien ket noi bo. Do la su that va phai noi; nhung nhac lai o moi lan
 *     bam thi nguoi dung se hoc cach khong doc no nua.
 *
 *  3. GHEP TEP PHAI XEM TRUOC. Ghep la thao tac duy nhat mang byte tu ben ngoai
 *     vao. Danh sach tep - kem so trang va kem TEP NAO KHONG DOC DUOC - duoc
 *     hien ra truoc, va nguoi dung xac nhan roi moi ghep. Nut chon tep nam o
 *     menu "Trang" tren thanh cong cu; buoc XAC NHAN o lai day, ngay tren anh
 *     thu nho, vi do la cho nguoi dung se nhin sau khi ghep xong.
 */
import { formatPageRange } from '../core/pages/ranges';

export interface MergePreviewFile {
  name: string;
  pageCount: number | null;
  /** Ly do tu choi. null nghia la tep nay ghep duoc. */
  error: string | null;
}

export interface PageToolbarProps {
  selected: ReadonlySet<number>;
  busy: boolean;

  /** Ghep: buoc 1 (chon tep) o menu "Trang"; buoc 2 (xac nhan) o day. */
  mergePreview: MergePreviewFile[] | null;
  onConfirmMerge: () => void;
  onCancelMerge: () => void;

  /** Canh bao mat mat, hien MOT LAN cho moi tai lieu. */
  warning: string | null;
  onDismissWarning: () => void;
}

export function PageToolbar({
  selected,
  busy,
  mergePreview,
  onConfirmMerge,
  onCancelMerge,
  warning,
  onDismissWarning,
}: PageToolbarProps) {
  const count = selected.size;
  const hasSelection = count > 0;

  return (
    <div className="pageOps">
      {warning && (
        <div className="pageOpsWarning" role="note">
          <span>{warning}</span>
          <button type="button" className="pageOpsWarningClose" onClick={onDismissWarning}>
            Đã hiểu
          </button>
        </div>
      )}

      {/*
        DONG NAY LA CAU NOI GIUA HAI KHUNG HINH. Cac nut "Xoay trái / Xoay phải /
        Xóa" tren thanh cong cu tac dong len DUNG tap trang nay; neu nguoi dung
        khong doc duoc minh dang chon gi thi ho dang bam mot nut xoa mu.
      */}
      <div className="pageOpsSelection" role="status">
        {hasSelection
          ? `Đang chọn ${count} trang: ${formatPageRange([...selected])}`
          : 'Chưa chọn trang nào — bấm một trang bên dưới (giữ Ctrl để chọn thêm, Shift để chọn cả dải).'}
      </div>

      {mergePreview && (
        <div className="pageOpsMerge" role="group" aria-label="Xác nhận ghép tệp">
          <div className="pageOpsMergeTitle">Sẽ ghép vào cuối tài liệu:</div>
          <ul className="pageOpsMergeList">
            {mergePreview.map((file, i) => (
              <li key={`${file.name}-${i}`} className={file.error ? 'bad' : ''}>
                <span className="pageOpsMergeName" title={file.name}>
                  {file.name}
                </span>
                <span className="pageOpsMergeMeta">
                  {file.error ? file.error : `${file.pageCount} trang`}
                </span>
              </li>
            ))}
          </ul>
          <div className="pageOpsRow">
            <button
              type="button"
              className="button small primary"
              disabled={busy || mergePreview.every((f) => f.error !== null)}
              onClick={onConfirmMerge}
            >
              Ghép
            </button>
            <button type="button" className="button small" onClick={onCancelMerge}>
              Hủy
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
